<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :rules="rules"
      :model="parentParticulars"
      label-width="80px"
    >
      <formTitle title="家長資料Parents’ Particulars"></formTitle>
      <div
        class="row-list"
        v-for="(item, index) in parentParticulars.parentParticulars"
        :key="index"
      > 
        <el-row type="flex" align="middle" style="margin-bottom: 10px;">
          <el-col :xl="12" :xs="24">
            <el-form-item label="" prop="parentParticulars">
              <el-radio-group :disabled="isView" v-model="isMainGuardianLabel" @change="mainGuardianChange(index,$event)">
                <el-radio v-show="index == 0" :label="0">主要申請人 Principal Applicant</el-radio>
                <el-radio v-show="index == 1" :label="1">主要申請人 Principal Applicant</el-radio>
                <el-radio v-show="index == 2" :label="2">主要申請人 Principal Applicant</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-col :xl="12" :xs="24">
            <div v-if="index == 0" class="plain-button-title">父親 Father</div>
            <div v-else-if="index == 1" class="plain-button-title">
              母親 Mother
            </div>
            <div v-else-if="index == 2" class="plain-button-title">
              監護人 Guardian
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :xl="12" :xs="24">
              <el-form-item label="英文姓名 Name in English " :prop="'parentParticulars.'+index + '.englishName'" :rules="[
                { required: item.isMainGuardian, message: '請輸入英文姓名', trigger: 'change' },
              ]">
                <el-input
                  :disabled="isView"
                  v-model="item.englishName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="12" :xs="24">
              <el-form-item label="中文姓名 Chinese Name" :prop="'parentParticulars.'+index + '.chineseName'" :rules="[{
                required: item.isMainGuardian, message: '請輸入中文姓名', trigger: 'change'
              }]">
                <el-input
                  :disabled="isView"
                  v-model="item.chineseName"
                ></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :xl="12" :xs="24">
              <el-form-item
                :disabled="isView"
                :prop="'parentParticulars.' + index + '.occupation'"
                :rules="[{
                required: item.isMainGuardian, message: '請輸入職業/專業', trigger: 'change'
                }]"
                label="職業/專業 Occupation/Profession "
              >
                <el-input :disabled="isView" v-model="item.occupation"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="12" :xs="24">
              <el-form-item label="機構 Organization " :prop="'parentParticulars.' + index + '.organization'" :rules="[{
                required: item.isMainGuardian, message: '請輸入機構', trigger: 'change'
              }]">
                <el-input
                  :disabled="isView"
                  v-model="item.organization"
                ></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :xl="12" :xs="24">
              <el-form-item
                label="辦公室電話 Office Tel."
                :prop="'parentParticulars.' + index + '.officeTel'"
                :rules="[
                  {
                    required: item.isMainGuardian, message: '請輸入辦公室電話', trigger: 'change'
                  },
                  {
                    pattern: /^[0-9]+$/,
                    message: '請輸入純數字',
                    trigger: 'change',
                  },
                ]"
              >
                <el-input
                  maxlength="8"
                  :disabled="isView"
                  v-model="item.officeTel"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :xl="12" :xs="24">
              <el-form-item
                label="手提電話 Mobile"
                :prop="'parentParticulars.' + index + '.mobile'"
                :rules="[
                  {
                    pattern: /^[0-9]+$/,
                    message: '請輸入純數字',
                    trigger: 'change',
                  },
                  {
                    required: item.isMainGuardian, message: '請輸入手提電話', trigger: 'change'
                  }
                ]"
              >
                <el-input
                  maxlength="8"
                  :disabled="isView"
                  v-model="item.mobile"
                ></el-input>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xl="12" :xs="24">
            <el-form-item
              label="電郵 Email "
              :prop="'parentParticulars.' + index + '.email'"
              :rules="[
                {
                  pattern:
                    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})+$/,
                  message: '請輸入正確的郵箱地址',
                  trigger: 'change',
                },
                {
                  required: item.isMainGuardian, message: '請輸入電郵', trigger: 'change'
                }
              ]"
            >
              <el-input :disabled="isView" v-model="item.email"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import formTitle from "@/components/formTitle";
export default {
  components: { formTitle },
  props: {
    parentParticulars: {
      type: Object,
      default: function () {},
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMainGuardianLabel:"",
      rules: {
        parentParticulars: [
          { 
            validator: this.validateList, 
            trigger: 'change' 
          }
        ]
    }
    };
  },
  watch:{
    'parentParticulars.parentParticulars':{
      handler(newVal){
        newVal.forEach((item,index)=>{
          if(item.isMainGuardian){
            this.isMainGuardianLabel = index
          }
        })
      },
      deep:true,
      immediate:true
    }
  },
  methods: {
    validateList(rule, value, callback) {
      const hasValidItem = value.some(item => item.isMainGuardian === true);
      if (!hasValidItem) {
        callback(new Error('至少需要选择一个项'));
      } else {
        callback();
      }
    },
    mainGuardianChange(index){
      this.parentParticulars.parentParticulars.forEach((item, i) => {
        if (i === index) {
          item.isMainGuardian = true;
        } else {
          item.isMainGuardian = false;
        }
      });
      // this.parentParticulars.parentParticulars[index].isMainGuardian = true
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="scss" scoped>
.document-identity-radio {
  display: flex;
  flex-direction: column;
}
.document-identity-radio .el-radio {
  display: flex;
  margin-bottom: 20px;
}
.el-button--primary {
  width: auto;
}
.row-list {
  padding: 30px 0;
  border-bottom: 1px solid #e5e5e5;
}
::v-deep {
  .el-input__inner {
    border-color: #72acff;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  ::v-deep {
    .el-form-item__label {
      line-height: 1.25rem;
    }
  }
}
</style>